import React from "react";
import { Switch, Route } from 'react-router-dom';
import { ROUTE_PATHS } from './core/routes';
import HomePage from "./pages/HomePage";
import ErrorPage from "./pages/ErrorPage";
import FormPage from "./pages/LoginPage";
import MainPage from "./pages/MainPage";
import LinksPage from "./pages/LinksPage";
import DocsPage from "./pages/DocsPage";
import RegisterPage from "./pages/RegisterPage";
import InfoPage from "./pages/InfoPage";
import CreateEventPage from "./pages/CreateEventPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import UsersListPage from "./pages/UsersListPage";
import DepartmentsListPage from "./pages/DepartmentsListPage";
import DepartmentDetailPage from "./pages/DepartmentPage";
import UsersBulkEditPage from "./pages/UsersBulkEditPage";
import WaitingListPage from "./pages/WaitingListPage";
import EventsListPage from "./pages/EventsListPage";
import { AuthProvider } from './core/AuthContext'; // Adjust the path if neededimport UserProfilePage from "./pages/UserProfilePage";
import { SemesterProvider } from './core/SemesterContext';
import { DepartmentsProvider } from './core/DepartmentsContext';
import UserProfilePage from "./pages/UserProfilePage";
import UserProfileDetailPage from "./pages/UserProfileDetailPage";
import WaitingForHRPage from "./pages/WaitingForHRPage";
import PlatformAccessRevokedPage from "./pages/PlatformAccessRevokedPage";
import EditEventPage from "./pages/EditEventPage";
import EditProfilePage from "./pages/EditProfilePage";
import CompareSardinesPage from "./pages/CompareSardinesPage";
import OpenCallPage from "./pages/OpenCallPage";
import OpenCallListPage from "./pages/OpenCallListPage";
import OpenCallResultsPage from "./pages/OpenCallResultsPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminStatsManagerPage from "./pages/AdminStatsManagerPage";
import EmailChangeConfirmationPage from "./pages/EmailChangeConfirmationPage";
import EmailVerificatedPage from "./pages/EmailVerificatedPage";
import EventCounterPage from "./pages/EventCounterPage";
import RoleManagementPage from "./pages/RoleManagementPage";
import PermissionManagementPage from "./pages/PermissionManagementPage";
import CreateSemesterPage from "./pages/CreateSemesterPage";
import SemesterManagementPage from "./pages/SemesterManagementPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";


import './index.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PrivateRoute from './components/PrivateRoute';
import OpenCallVotingPage from "./pages/OpenCallVoting";

export default function App() {
    AOS.init();
    //console.log(store.getState());

    return (
        <AuthProvider> {/* Wrap the Switch in AuthProvider */}
            <SemesterProvider>
              <DepartmentsProvider>
              <Switch>
                {/* Public routes — paths defined in core/routes.js */}
                <Route exact path={ROUTE_PATHS.home} component={HomePage} />
                <Route path={ROUTE_PATHS.login} component={FormPage} />
                <Route path={ROUTE_PATHS.register} component={RegisterPage} />
                <Route path={ROUTE_PATHS.forgotPassword} component={ForgotPasswordPage} />
                <Route path={ROUTE_PATHS.info} component={InfoPage} />
                <Route path={ROUTE_PATHS.waitingForHr} component={WaitingForHRPage} />
                <Route path={ROUTE_PATHS.platformAccessRevoked} component={PlatformAccessRevokedPage} />
                <PrivateRoute path="/unauthorized" component={UnauthorizedPage} />
                <Route path={ROUTE_PATHS.openCall} component={OpenCallPage} />
                <PrivateRoute path="/events/:eventId/counter" component={EventCounterPage} />
                <Route path={ROUTE_PATHS.editEvent} component={EditEventPage} />

                <Route path={ROUTE_PATHS.resetPassword} component={ResetPasswordPage} />
                <Route path={ROUTE_PATHS.confirmEmailChange} component={EmailChangeConfirmationPage} />
                <Route path={ROUTE_PATHS.verifyEmail} component={EmailVerificatedPage} />

                {/* Protected Routes */}
                <PrivateRoute path="/main" component={MainPage} />
                <PrivateRoute path="/links" component={LinksPage} />
                <PrivateRoute path="/documents" component={DocsPage} />
                <PrivateRoute path="/create-event" component={CreateEventPage} />
                <PrivateRoute path="/users-list" component={UsersListPage} />
                <PrivateRoute path="/departments-list" component={DepartmentsListPage} />
                <PrivateRoute path="/departments/:departmentId" component={DepartmentDetailPage} />
                <PrivateRoute path="/users-bulk-edit" component={UsersBulkEditPage} />
                <PrivateRoute path="/events-list" component={EventsListPage} />
                <PrivateRoute path="/opencalls-list" component={OpenCallListPage} />
                <PrivateRoute path="/opencalls/:opencallId/compare-sardines" component={OpenCallVotingPage} />
                <PrivateRoute path="/opencalls/:opencallId" component={OpenCallResultsPage} />
                <PrivateRoute path="/user-profile" component={UserProfilePage} />
                <PrivateRoute path="/waiting-list" component={WaitingListPage} />
                <PrivateRoute path="/users/:userId/edit" component={EditProfilePage} />
                <PrivateRoute path="/users/:userId/details" component={UserProfileDetailPage} />
                <PrivateRoute path="/users/:userId" component={UserProfilePage} />
                <PrivateRoute path="/compare-sardines" component={CompareSardinesPage} />
                <PrivateRoute path="/admin-stats-manager" component={AdminStatsManagerPage} />
                <PrivateRoute path="/role-management" component={RoleManagementPage} />
                <PrivateRoute path="/permission-management" component={PermissionManagementPage} />
                <PrivateRoute path="/semesters/new" component={CreateSemesterPage} />
                <PrivateRoute path="/semester-management" component={SemesterManagementPage} />

                {/* <PrivateRoute path="/reset-password" component={ResetPasswordPage} /> */}



                {/* Fallback route */}
                {/* <Route component={ErrorPage} /> */}
                <Route component={HomePage} />

              </Switch>
              </DepartmentsProvider>
            </SemesterProvider>
        </AuthProvider>
    );
}
